"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleTypeNameTransformer = exports.ArticleTypePluralExtended = exports.ArticleTypePlural = exports.allArticleTypes = exports.ArticleType = void 0;
/* eslint-disable deprecation/deprecation */
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
var echain_prisma_client_2 = require("@igus/echain-prisma-client");
Object.defineProperty(exports, "ArticleType", { enumerable: true, get: function () { return echain_prisma_client_2.ArticleType; } });
/** Array with all ArticleTypes */
exports.allArticleTypes = (0, echain_shared_ts_utils_1.getStringEnumValues)(echain_prisma_client_1.ArticleType);
/**
 * @deprecated always use `ArticleType` or make yourself a private mapping for whatever you want to do.
 */
var ArticleTypePlural;
(function (ArticleTypePlural) {
    ArticleTypePlural["leitungen"] = "leitungen";
    ArticleTypePlural["links"] = "links";
    ArticleTypePlural["ketten"] = "ketten";
    ArticleTypePlural["aes"] = "aes";
    ArticleTypePlural["ias"] = "ias";
    ArticleTypePlural["zugentlastungen"] = "zugentlastungen";
    ArticleTypePlural["verpackungen"] = "verpackungen";
    ArticleTypePlural["konfektionierungen"] = "konfektionierungen";
    ArticleTypePlural["fuehrungsrinnen"] = "fuehrungsrinnen";
    ArticleTypePlural["montageSets"] = "montageSets";
    ArticleTypePlural["montBes"] = "montBes";
    ArticleTypePlural["espools"] = "espools";
    ArticleTypePlural["zubehoer"] = "zubehoer";
})(ArticleTypePlural = exports.ArticleTypePlural || (exports.ArticleTypePlural = {}));
/**
 * @deprecated always use `ArticleType` or make yourself a private mapping for whatever you want to do.
 */
var ArticleTypePluralExtended;
(function (ArticleTypePluralExtended) {
    ArticleTypePluralExtended["leitungen"] = "leitungen";
    ArticleTypePluralExtended["links"] = "links";
    ArticleTypePluralExtended["ketten"] = "ketten";
    ArticleTypePluralExtended["anschlusselemente"] = "anschlusselemente";
    ArticleTypePluralExtended["innenaufteilungselemente"] = "innenaufteilungselemente";
    ArticleTypePluralExtended["zugentlastungen"] = "zugentlastungen";
    ArticleTypePluralExtended["verpackungen"] = "verpackungen";
    ArticleTypePluralExtended["konfektionierungen"] = "konfektionierungen";
    ArticleTypePluralExtended["rinnen"] = "rinnen";
    ArticleTypePluralExtended["montageSets"] = "montageSets";
    ArticleTypePluralExtended["montBes"] = "montBes";
    ArticleTypePluralExtended["espools"] = "espools";
    ArticleTypePluralExtended["zubehoer"] = "zubehoer";
})(ArticleTypePluralExtended = exports.ArticleTypePluralExtended || (exports.ArticleTypePluralExtended = {}));
const articleTypeToPluralMap = {
    [echain_prisma_client_1.ArticleType.leitung]: ArticleTypePlural.leitungen,
    [echain_prisma_client_1.ArticleType.link]: ArticleTypePlural.links,
    [echain_prisma_client_1.ArticleType.kette]: ArticleTypePlural.ketten,
    [echain_prisma_client_1.ArticleType.ae]: ArticleTypePlural.aes,
    [echain_prisma_client_1.ArticleType.ia]: ArticleTypePlural.ias,
    [echain_prisma_client_1.ArticleType.zugentlastung]: ArticleTypePlural.zugentlastungen,
    [echain_prisma_client_1.ArticleType.verpackung]: ArticleTypePlural.verpackungen,
    [echain_prisma_client_1.ArticleType.konfektionierung]: ArticleTypePlural.konfektionierungen,
    [echain_prisma_client_1.ArticleType.fuehrungsrinne]: ArticleTypePlural.fuehrungsrinnen,
    [echain_prisma_client_1.ArticleType.montageSet]: ArticleTypePlural.montageSets,
    [echain_prisma_client_1.ArticleType.montBes]: ArticleTypePlural.montBes,
    [echain_prisma_client_1.ArticleType.espool]: ArticleTypePlural.espools,
    [echain_prisma_client_1.ArticleType.zubehoer]: ArticleTypePlural.zubehoer,
};
const articleTypeToPluralExtendedMap = {
    [echain_prisma_client_1.ArticleType.leitung]: ArticleTypePluralExtended.leitungen,
    [echain_prisma_client_1.ArticleType.link]: ArticleTypePluralExtended.links,
    [echain_prisma_client_1.ArticleType.kette]: ArticleTypePluralExtended.ketten,
    [echain_prisma_client_1.ArticleType.ae]: ArticleTypePluralExtended.anschlusselemente,
    [echain_prisma_client_1.ArticleType.ia]: ArticleTypePluralExtended.innenaufteilungselemente,
    [echain_prisma_client_1.ArticleType.zugentlastung]: ArticleTypePluralExtended.zugentlastungen,
    [echain_prisma_client_1.ArticleType.verpackung]: ArticleTypePluralExtended.verpackungen,
    [echain_prisma_client_1.ArticleType.konfektionierung]: ArticleTypePluralExtended.konfektionierungen,
    [echain_prisma_client_1.ArticleType.fuehrungsrinne]: ArticleTypePluralExtended.rinnen,
    [echain_prisma_client_1.ArticleType.montageSet]: ArticleTypePluralExtended.montageSets,
    [echain_prisma_client_1.ArticleType.montBes]: ArticleTypePluralExtended.montBes,
    [echain_prisma_client_1.ArticleType.espool]: ArticleTypePluralExtended.espools,
    [echain_prisma_client_1.ArticleType.zubehoer]: ArticleTypePluralExtended.zubehoer,
};
/**
 * @deprecated always use `ArticleType` or make yourself a private mapping for whatever you want to do.
 */
class ArticleTypeNameTransformer {
    static articleTypeToPlural(singularName) {
        return articleTypeToPluralMap[singularName];
    }
    static articleTypeToPluralExtended(singularName) {
        return articleTypeToPluralExtendedMap[singularName];
    }
}
exports.ArticleTypeNameTransformer = ArticleTypeNameTransformer;
//# sourceMappingURL=ArticleType.js.map